export default __webpack_public_path__ + "static/media/RockPaperScissor.c9bf23f2.jpg";